import EmbedWidget from "QuorumGrassroots/widgets/Embed/components"

export default EmbedWidget
